import { makeStyles, Theme } from '@material-ui/core';

const etcButtonSize = '300px';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    marginBottom: '30px',
  },
  pillBtn: {
    width: '100%',
    height: '50px',
  },
  registerBtn: {
    backgroundColor: '#F9E2E4',
    width: etcButtonSize,
    height: '30px',
    margin: '10px 0',
  },
  typography: {
    width: '350px',
    textAlign: 'center',
    marginTop: '20px',
  },
  forgotPasswordBtn: {
    backgroundColor: '#606060',
    width: etcButtonSize,
    height: '30px',
    margin: '10px 0',
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
    textAlign: 'center',
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));
export default useStyles;
